<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>
          <div class="row">
            <div class="col-8">
              <h4 class="card-title text-purple mt-4">
                {{ $t("app.modules.products.title") }}
              </h4>
            </div>
            <div class="col-4 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <fg-input>
                <el-input
                  type="search"
                  class="mt-4"
                  clearable
                  prefix-icon="el-icon-search"
                  style="width: 300px"
                  v-model="searchQuery"
                  :placeholder="$t('app.general.search')"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>
            <div class="col-12">
              <el-table stripe style="width: 100%;" :data="queriedData">
                <el-table-column  :label="$t('app.modules.products.headers.family')">
                  <template slot-scope="scope">
                    {{ scope | product('productoPadre')}}
                  </template>
                </el-table-column>
                <el-table-column  :label="$t('app.modules.products.headers.SAPCode')">
                  <template slot-scope="scope">
                    {{ scope | product('material') }}
                  </template>
                </el-table-column>
                <el-table-column  :label="$t('app.modules.products.headers.SAPDescription')">
                  <template slot-scope="scope">
                    {{ scope | product('textoBreveMaterial') }}
                  </template>
                </el-table-column>
                <el-table-column className="is-center"
                                 labelClassName="is-center" :label="$t('app.modules.products.headers.published')">
                  <template slot-scope="scope" >
                    <i v-if="scope.row.product['publicado']" class="fa fa-check indicator success"></i>
                    <i v-else class="fa fa-times indicator danger"></i>
                  </template>
                </el-table-column>
                <el-table-column className="is-center"
                                 labelClassName="is-center" :label="$t('app.modules.products.headers.enhanced')">
                  <template slot-scope="scope">
                    <i class="fa fa-check indicator success" v-if="scope.row.product['enriquecido']"></i>
                    <i class="fa fa-times indicator danger" v-else></i>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed="right" label="">
                  <div slot-scope="scope" class="table-actions dropdown">
                    <el-popover
                      placement="bottom"
                      width="250"
                      trigger="click"
                      :ref="'refOption' + scope.$index"
                    >
                      <div class="row">
                        <div class="col-12 options">
                          <n-button
                            @click.native="openEnhance(scope.row.product['idProducto'], 'refOption' + scope.$index)"
                            type="primary"
                            class="options-button"
                            size="sm"
                            round
                          >
                            {{ $t("app.modules.products.actions.enhance") }}
                          </n-button>
                        </div>
                        <div class="col-12 options" v-if="!scope.row.product['publicado']">
                          <n-button
                            @click.native="publishProduct(scope.row.product['idProducto'], 'refOption' + scope.$index)"
                            type="primary"
                            class="options-button"
                            size="sm"
                            round
                          >
                            {{ $t("app.modules.products.actions.publish") }}
                          </n-button>
                        </div>
                        <div class="col-12 options" v-else>
                          <n-button
                            @click.native="unpublishProduct(scope.row.product['idProducto'], 'refOption' + scope.$index)"
                            type="secondary"
                            class="options-button"
                            size="sm"
                            round
                          >
                              {{ $t("app.modules.products.actions.unpublish") }}
                          </n-button>
                        </div>
                        <div class="col-12 options">
                          <n-button
                            @click.native="showDetails(scope.row.product['idProducto'], 'refOption' + scope.$index)"
                            type="primary"
                            class="options-button"
                            size="sm"
                            round
                          >
                            {{ $t("app.modules.products.actions.details") }}
                          </n-button>
                        </div>
                      </div>
                      <n-button
                        slot="reference"
                        size="sm"
                        icon
                        style="background-color:white;"
                      >
                        <i class="fa fa-ellipsis-v" style="color:black;"></i>
                      </n-button>
                    </el-popover>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                {{ $t("app.pagination.showing") }} {{ from + 1 }} {{$t("app.pagination.to") }} {{ to }} {{$t("app.pagination.of")}} {{ total }} {{$t("app.pagination.records")}}
              </p>
            </div>
            <n-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </n-pagination>
          </div>
        </card>
        <product-enhance></product-enhance>
        <product-detail></product-detail>
      </div>
    </div>
  </div>

</template>

<script>
import {getResponse} from "@/util/utilities";
import OrderItemInformation from "@/models/pedidos/OrderItemInformation";
import ProductEnhance from "./ProductEnhance";
import ProductDetail from "./ProductDetail";

export default {
  name: "ProductosMain",

  components: {
    ProductEnhance,
    ProductDetail
  },
  data(){
    return{
      productos: [],
      searchedData: [],
      searchQuery: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    }
  },
  computed:{
    queriedData() {
      let result = this.productos;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.productos.length;
    }
  },
  mounted(){
    let vm = this;
    this.init();
    EventBus.$on("product-enhance-success", async f => {
      await this.getProductos();
    });
  },
  methods:{
    async init(){
      this.showLoader();
      await this.getProductos();
      this.closeLoader();
    },
    showLoader()
    {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
    },
    closeLoader(){
      this.$swal.close();
    },
    async getProductos(searchString = null){
      const params = {
        searchString: searchString
      };

      this.productos = [];

      try {
        let productosRequest = await this.$http.post(route("Productos/getAllProductos"), params)

        let productos = getResponse(productosRequest, null, body => body.productos);
        productos = productos || [];
        productos = productos.map(product => {
          return new OrderItemInformation({product, quantity: 0});
        });

        this.productos = productos;
      }
      catch (e)
      {
        console.error(e);
      }
    },
    openEnhance(idProducto, ref){
      this.$refs[ref].doClose();
      EventBus.$emit("product-enhance", idProducto);
    },
    async publishProduct(idProducto, ref){
      this.$refs[ref].doClose();
      const params = {
        idProducto: idProducto
      };
      try {
        this.showLoader();
        let productoRequest = await this.$http.put(route("Productos/PublishProduct"), params)
        let code = getResponse(productoRequest, null, body => body.code);
        this.$swal.close();
        if(code == 200){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
        } else {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      } catch (e) {
        console.error(e);
        this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      this.getProductos();
    },
    async unpublishProduct(idProducto, ref){
      this.$refs[ref].doClose();
      const params = {
        idProducto: idProducto
      };
      try {
        this.showLoader();
        let productoRequest = await this.$http.put(route("Productos/UnpublishProduct"), params)
        let code = getResponse(productoRequest, null, body => body.code);
        this.$swal.close();
        if(code == 200){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
        } else {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      } catch (e) {
        console.error(e);
        this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      this.getProductos();
    },
    showDetails(idProducto, ref){
      this.$refs[ref].doClose();
      EventBus.$emit("product-details", idProducto);
    }
  },
  filters: {
    product(value, prop = null)
    {
      let row = value.row;
      if (!!row) {
        let product = row.product;
        if (!!product && !!prop) {
          if(prop === "productoPadre"){
            return product[prop]? product[prop]: "N/A";
          }
          return product[prop];
        }

        return product;
      }
      return null;
    }
  },
  watch: {
    async searchQuery(value) {
        await this.getProductos(value);
    }
  }
};
</script>

<style scoped>
.indicator {
  font-size: 30px;
}
.indicator.success {
  color: #18ce0f;
}
.indicator.danger {
  color: #ff3636;
}
</style>
